<template>
    <div
        :data-component-name="$options.name"
        :class="(!field.inputClass) ? 'o-grid-12' : field.inputClass"
        v-if="!disabledIDs.includes(field.id)"
    >
        <inputlabel :field="field" />
        <div class="o-form__item">
            <div class="o-select__wrap">
                <select
                    class="o-select"
                    :class="{ 'readonly': field.inputReadonly === true }"
                    v-on="readOnlyHandlers"
                    type="text"
                    v-model="field.value"
                    :id="'input-' + field.id"
                    :name="field.inputName"
                    :placeholder="field.inputPlaceholder"
                    :required="(field.inputRequired === true) ? 'required' : false"
                    :multiple="(field.inputChoicesMultiple === true) ? 'multiple' : false"
                    :autocomplete="(field.inputAutocomplete && field.inputAutocomplete != '' && field.inputAutocomplete != 'querystring' && field.inputAutocomplete != 'reactivevalue' && field.inputAutocomplete != 'cookie') ? field.inputAutocomplete : false"
                >
                    <option :value="''" disabled selected>{{ (field.inputPlaceholder !== null && field.inputPlaceholder != '') ? field.inputPlaceholder : _t('Choisir') }}</option>

                    <option
                        v-for="(choice, ci) in field.inputChoices"
                        :key="'cb-'+ci+'-'+field.id"
                        :value="(String(choice.value).trim() != '') ? choice.value : choice.text"
                        v-html="(String(choice.text).trim() != '') ? String(choice.text) : String(choice.value)"
                    >
                    </option>
                </select>
                <div class="o-form__validation">
                    <span class="o-form__validation__required">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                    <span class="o-form__validation__error">
                        {{ _t('Ce champ est obligatoire.') }}
                    </span>
                </div>
            </div>
        </div>
        <span class="o-form__instruction" v-if="field.inputInstructions && String(field.inputInstructions).trim() != ''">
            <small v-html="field.inputInstructions"></small>
        </span>
    </div>
</template>
<script>
    export default {
        name: 'Input-select',
        props: {
            field: {
                type: Object,
                default() {
                    return {}
                },
            },
            disabledIDs: {
                type: Array,
                default() {
                    return []
                },
            },
        },
        data(){
        	return {
                readOnlyHandlers: {
                    keydown: this.handleEvent,
                    paste: this.handleEvent,
                    focus: this.handleEvent,
                    mousedown: this.handleEvent,
                }
        	}
        },
        mounted() {
            if (this.field.value === null) {
                let defaultValue = this.field.inputChoices.find(choice => choice.default);
                if (defaultValue) {
                    this.field.value = (String(defaultValue.value).trim() != '') ? defaultValue.value : defaultValue.text;
                }else{
                    this.field.value = '';
                }
            }
            
        },
        methods: {
            handleEvent(e) {
                if (this.field.inputReadonly === true && (!e.keyCode || e.keyCode != 9)) e.preventDefault();
            }
        },
    }
</script>